// import React, { useState } from "react";
// import faq from "./data/faq.json";

// const FAQ = () => {

//   return (
//     <>
//       <section className="faq-section " id="faq"  data-aos="zoom-in"  data-aos-duration="1000">
//         <div className="container" >
//           <div className="row d-flex justify-content-center align-content-center mx-auto" >
//             <div className="col-sm-12 col-md-12 ">
//               <div className="faq-title text-center pb-3">
//                 <h2 className="mb-5 mt-0 text-center">FAQ</h2>
//               </div>
//             </div>
//             {/* What is Lorem Ipsum? */}
//             <div className="col-sm-12 col-md-12 ">
//               <div className="faq" id="accordion" >
//                 <div className="card">
//                   {faq.map((data) => (
//                     <>
//                       <div className="card-header" id="faqHeading-1" >
//                         <div className="mb-0">
//                           <h5
//                             className="faq-title"
//                             data-toggle="collapse"
//                             data-target="#faqCollapse-1"
//                             data-aria-expanded="true"
//                             data-aria-controls="faqCollapse-1"
//                           >
//                             <span className="badge">{data.key}</span>{" "}
//                             {data.heading}
//                           </h5>
//                         </div>
//                       </div>
//                       <div
//                         id="faqCollapse-1"
//                         className="collapse"
//                         aria-labelledby="faqHeading-1"
//                         data-parent="#accordion"
//                       >
//                         <div className="card-body" style={{color:"yellowgreen"}}>
//                           <p> {data.description} </p>
//                         </div>
//                       </div>
//                     </>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default FAQ;


import React, { useState } from "react";
import faq from "./data/faq.json";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleFAQ = (index) => {
    if (activeIndex === index) {
      // If the same FAQ is clicked, close it
      setActiveIndex(null);
    } else {
      // Open the clicked FAQ
      // const heading = document.getElementById("faq-heading");
      // heading.style.color = "purple";
      setActiveIndex(index);
    }
  };

  return (
    <>
      <section
        className="faq-section"
        id="faq"
        data-aos="zoom-in"
        data-aos-duration="1000"
      >
        <div className="container">
          <div className="row d-flex justify-content-center align-content-center mx-auto">
            <div className="col-sm-12 col-md-12">
              <div className="faq-title text-center pb-3">
                <h2 className="mb-5 mt-0 text-center">FAQ</h2>
              </div>
            </div>
            <div className="col-sm-12 col-md-12">
              <div className="faq" id="accordion">
                <div className="card">
                  {faq.map((data, index) => (
                    <React.Fragment key={index}>
                      <div className="card-header" id={`faqHeading-${index}`}>
                        <div className="mb-0">
                          <h5
                            className="faq-title"
                            onClick={() => toggleFAQ(index)}
                            style={{ cursor: "pointer" }}
                            id="faq-heading"
                          >
                            <span className="badge">{data.key}</span> {data.heading}
                          </h5>
                        </div>
                      </div>
                      <div
                        id={`faqCollapse-${index}`}
                        className={`collapse ${activeIndex === index ? "show" : "" }`}
                        aria-labelledby={`faqHeading-${index}`}
                        data-parent="#accordion"
                      >
                        <div className="card-body text-white">
                          <p>{data.description}</p>
                        </div>
                      </div>
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQ;
